import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal, MaskedLine } from "@/components/Reveal";
import { scrollToId } from "@/lib/lenis";

export default function LimitedCTA() {
  return (
    <section className="py-24 sm:py-32 lg:py-40" data-testid="limited-availability-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="flex items-center gap-4 mb-8">
            <span className="relative flex h-3 w-3">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#CCFF00] opacity-60" />
              <span className="relative inline-flex rounded-full h-3 w-3 bg-[#CCFF00]" />
            </span>
            <span
              className="text-xs uppercase tracking-[0.3em] text-[#CCFF00] font-mono2"
              data-testid="limited-badge"
            >
              Limited Availability
            </span>
          </div>
        </Reveal>

        <h2 className="font-display uppercase text-white leading-[0.9] tracking-tight text-5xl sm:text-7xl lg:text-8xl">
          <MaskedLine delay={0.1}>A Small Roster,</MaskedLine>
          <MaskedLine delay={0.22}>
            <span className="text-[#CCFF00]">On Purpose.</span>
          </MaskedLine>
        </h2>

        <Reveal delay={0.3}>
          <p className="mt-8 max-w-2xl text-base sm:text-lg text-zinc-400 leading-relaxed">
            I intentionally keep my 1-on-1 roster small. Every athlete gets real
            attention — real programming, real adjustments, real conversations.
            When the roster is full, applications wait for the next opening.
          </p>
        </Reveal>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="mt-16 sm:mt-20 border border-zinc-800 bg-[#141416] p-8 sm:p-12 lg:p-16"
          data-testid="final-cta-block"
        >
          <p className="section-label mb-5">Final Call</p>
          <h3 className="font-display uppercase text-white leading-[0.9] text-4xl sm:text-6xl lg:text-7xl tracking-tight mb-6">
            See If You're A Good Fit
          </h3>
          <p className="max-w-xl text-sm sm:text-base text-zinc-400 leading-relaxed mb-10">
            The application takes two minutes. If your goals and commitment match
            the standard, I'll reach out to you directly.
          </p>
          <button
            onClick={() => scrollToId("#apply")}
            data-testid="final-apply-cta"
            className="group inline-flex items-center gap-3 bg-[#CCFF00] text-[#0B0B0C] font-bold uppercase tracking-[0.15em] text-sm px-10 py-5 transition-transform duration-300 hover:-translate-y-0.5"
          >
            Apply Now
            <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
          </button>
        </motion.div>
      </div>
    </section>
  );
}
